// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46e21837","455":"9f450602"}[chunkId] + ".chunk.js";
};